import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './fonts/Myriad-Pro-Regular.ttf';

ReactDOM.render(<App />, document.getElementById('root'));
